import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";  // or other services you want to use
import { connectAuthEmulator } from 'firebase/auth';

import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';


// Initialize Firebase
const app = initializeApp({
    apiKey: "AIzaSyDV4hFqDrKUVoDAx2WCz7D0f2i5VxyP-RA",
    authDomain: "app-fantamusie.firebaseapp.com",
    projectId: "app-fantamusie",
    storageBucket: "app-fantamusie.appspot.com",
    messagingSenderId: "350479694758",
    appId: "1:350479694758:web:5368aa8b0e3cb7af956d67",
    measurementId: "G-F4NWQYGREF"
  })

const auth = getAuth(app); // const { uid } = auth.currentUser; // Get current user's uid
const firestore = getFirestore(app);
const analytics = getAnalytics(app);

if(location.hostname === '127.0.0.1') {
  console.log('Using emulator for firestore ------------------------------------');
  connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
  connectAuthEmulator(auth, 'http://127.0.0.1:9099');

  // connectFunctionsEmulator(functions, 'localhost', 5001);
}

// Backend - direct Functions
// const functions = getFunctions(app, "europe-west3");
// const signInFunc = httpsCallable(functions, 'signIn');

export { auth, firestore, analytics }; // signInFunc
